/**
 * NDG Brevo Form — view.js
 *
 * Store Interactivity API pour le formulaire d'inscription newsletter Brevo.
 */

import { store, getContext } from '@wordpress/interactivity';
import { getRecaptchaToken, preloadRecaptcha } from '../../js/utils/recaptcha.js';

const STORE_NS = 'ndg/brevo-form';

store( STORE_NS, {

	actions: {

		preloadRecaptcha() {
			preloadRecaptcha( getContext().recaptchaSiteKey );
		},

		setEmail( event ) {
			getContext().email = event.target.value;
		},

		setFirstname( event ) {
			getContext().firstname = event.target.value;
		},

		setLastname( event ) {
			getContext().lastname = event.target.value;
		},

		*subscribe( event ) {
			event.preventDefault();

			const context = getContext();

			if ( context.isSubmitting ) return;

			context.isSubmitting = true;
			context.isSuccess    = false;
			context.isError      = false;

			try {
				const token = yield getRecaptchaToken( context.recaptchaSiteKey, context.recaptchaAction );

				const response = yield fetch( context.restUrl, {
					method:  'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce':   context.nonce,
					},
					body: JSON.stringify( {
						email:           context.email,
						firstname:       context.firstname,
						lastname:        context.lastname,
						recaptcha_token: token,
					} ),
				} );

				const data = yield response.json();

				if ( response.ok && data.ok ) {
					context.isSuccess = true;
					context.email     = '';
					context.firstname = '';
					context.lastname  = '';
				} else {
					context.isError = true;
				}
			} catch {
				context.isError = true;
			} finally {
				context.isSubmitting = false;
			}
		},
	},
} );
